import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Column from "./SupportTicketColumnBoard";

const Container = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 70px;
`;

const SupportTicketBoard = ({
  isCombineEnabled,
  auth,
  onDragEnd,
  onTicketClick,
  supportTicketsBoard,
  loadMoreSupportTicketsBoard,
  loading
}) => {
  const handleDragEnd = (result) => {
    onDragEnd(result);
  };

  return (
    <React.Fragment>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable
          ignoreContainerClipping
          direction="horizontal"
          droppableId="board"
          isCombineEnabled={isCombineEnabled}
          type="COLUMN"
        >
          {(provided) => (
            <Container ref={provided.innerRef} {...provided.droppableProps}>
              {!!supportTicketsBoard.length &&
                supportTicketsBoard.map((availableStatus, index) => (
                  <Column
                    isScrollable
                    key={availableStatus.label}
                    auth={auth}
                    title={availableStatus.label}
                    index={index}
                    isCombineEnabled={isCombineEnabled}
                    items={availableStatus.tickets}
                    onLoadMoreClick={loadMoreSupportTicketsBoard}
                    onLoadMoreEnabled={
                      availableStatus.page !== availableStatus.pages && !loading
                    }
                    removePackageTest={() => null}
                    name={availableStatus.label}
                    onTicketClick={onTicketClick}
                    hideLoadMore={availableStatus.missingItems <= 0}
                  />
                ))}
            </Container>
          )}
        </Droppable>
      </DragDropContext>
    </React.Fragment>
  );
};
SupportTicketBoard.propTypes = {
  isCombineEnabled: PropTypes.bool,
  supportTicketsBoard: PropTypes.array,
  loadMoreSupportTicketsBoard: PropTypes.func,
  auth: PropTypes.object,
  history: PropTypes.object,
  onDragEnd: PropTypes.func.isRequired,
  onTicketClick: PropTypes.func.isRequired,
  loading: PropTypes.bool
};
SupportTicketBoard.defaultProps = {
  isCombineEnabled: false,
  loadMoreSupportTicketsBoard: () => null,
  loading: false
};

export default SupportTicketBoard;
